import './style.css'

function main() {
  var coverOpacity = 1;

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let sourceTarget = params.id;

  // Check if rerender exists
  let img = new Image()
  img.src = `https://customisoroom.s3.amazonaws.com/${sourceTarget}.jpg`;
  img.onload = () => {
    console.log('run block');
    document.getElementById("button").style.display = 'block';
    document.getElementById('rerender').src 
      = `https://customisoroom.s3.amazonaws.com/${sourceTarget}.jpg`;
  }

  document.getElementById("button").addEventListener("click", () => {
    if (coverOpacity === 1) {
      /**
       * Show
       */
      coverOpacity = 0;
      document.getElementById('cover').style.opacity = 0;
      document.getElementById('button').innerHTML = 'Back'
      setTimeout(() => {
        document.getElementById('cover').style.display = 'none';
      }, 300)
    } else {
      /**
       * Hide
       */
      coverOpacity = 1;
      document.getElementById('button').innerHTML = '<img src="https://rcvc.io/srm/isoroom-h-logo.png" style="width: 20px; height: 20px; margin-right: 5px;"></img> Show NFTs'
      document.getElementById('cover').style.display = 'block';
      setTimeout(() => {
        document.getElementById('cover').style.opacity = 1;
      }, 100)
    }
  });
}

main();